import { render, staticRenderFns } from "./DriverBox.vue?vue&type=template&id=4360dcc9&scoped=true&lang=pug"
import script from "./DriverBox.vue?vue&type=script&lang=js"
export * from "./DriverBox.vue?vue&type=script&lang=js"
import style0 from "./DriverBox.vue?vue&type=style&index=0&id=4360dcc9&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4360dcc9",
  null
  
)

export default component.exports